(function($) {
	
	$.fn.decorField = function() {
		var elem = $(this),
			input = elem.find('.js-decor-field__input'),
			value = elem.find('.js-decor-field__value'),
			settings = {
				changeEvent: 'change',
				pickerClass: '',
				activeClass: 'is-active'
			};
		
		var init = function() {

			// Check that it's worth even tiying up this code
			if(input.any() && value.any()) {
				
				// Set a timeout and update the display element's value
				setTimeout(function() {
					update();
				}, 50);
				
				// Run an update for every change
				input.on(input.changeEvent(), function() {
					update();
				});

				// Add active class on focus and remove on blur
				input.on('focus', function() {
					input.parent().addClass(settings.activeClass);
				}).
				on('blur', function() {
					input.parent().removeClass(settings.activeClass);
				});
			}
		},
		
		// Update value of display element
		update = function() {

			var stdVal = input.val(),
				textVal = input.find(':selected').text();

			// Check for any value
			if(stdVal || textVal) {
				
				// Set text if there 
				if(textVal) {
					value.text(textVal);
				}
				
				// Set val by default
				else {
					value.text(stdVal);
				}
			}
			
		};
		
		init();
		return this;
			
	};
	
}($));